import * as React from "react";
import { Container, Grid, Typography, useMediaQuery } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import Content from "../components/DialogContent";
import { endDateOfDiscount } from "../App";
import Content2 from "../components/DialogContent2";
import RulesContent from "../components/RulesContent";

const Discount = () => {
  const lgDown = useMediaQuery((theme) => theme.breakpoints.down("lg"));

  const { t } = useTranslation();

  const isDiscountContent = (endDateOfDiscount) => {
    const today = new Date();
    const endDateOfDiscountDate = new Date(endDateOfDiscount);
    return today < endDateOfDiscountDate;
  };

  return (
    <Container maxWidth="lg">
      <Grid container mb={10} mt={10} gap={12}>
        {isDiscountContent(endDateOfDiscount) && (
          <>
            <Grid item md={12} xs={12} mt={0}>
              <Grid container>
                <Grid item md={12} sx={12}>
                  <Content />
                </Grid>
              </Grid>
            </Grid>
            {/* <Grid item md={12} xs={12} mt={0}>
              <Grid container>
                <Grid item md={12} sx={12}>
                  <Content2 />
                </Grid>
              </Grid>
            </Grid> */}
          </>
        )}
        <Grid item md={12} xs={12}>
          <Grid container>
            <Grid item md={12} sx={12}>
              <Typography
                variant="h3"
                color="primary"
                fontWeight="bold"
                textAlign="center"
                mb={8}
              >
                {t("disc1")}
              </Typography>
              <Typography
                mt={1}
                textAlign="left"
                variant="body1"
                fontWeight="bold"
              >
                <li>{t("disc2")}</li>
              </Typography>
              <Typography mt={1} variant="body1" textAlign="left">
                {t("disc3")}
              </Typography>
            </Grid>
          </Grid>
          <Grid container alignItems="center" mt={0} p={lgDown ? 1 : 2}>
            <Grid item md={6} sm={6} alignItems="center">
              <Typography textAlign="left" m={1}>
                🔥 {t("disc4")}
              </Typography>
              <Typography textAlign="left" m={1}>
                🔥 {t("disc5")}
              </Typography>
              <Typography textAlign="left" m={1}>
                🔥 {t("disc6")}
              </Typography>
            </Grid>
          </Grid>
          <Grid container>
            <Grid item mt={0} alignItems="center" md={12}>
              <Typography variant="body2">{t("disc7")}</Typography>
              <Typography variant="body1" fontWeight="bold" mt={3}>
                {t("disc8")}
              </Typography>
              <Typography variant="body1" fontWeight="bold">
                {t("disc9")}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <RulesContent />
    </Container>
  );
};

export default Discount;
